import { FleetRegistrationNoAuthService } from '@gen/driverPortal/fleetRegistrationNoAuth';
import { HttpClientBoltServer } from '@bolteu/http-client-bolt-server';
import { getAppBrand, getServerHost } from '../common/environment';
import { PORTAL_VERSION } from '../env';

const documentsHttpClient =
  new HttpClientBoltServer<FleetRegistrationNoAuthService.HttpClientConstraints>(
    {
      baseUrl: getServerHost(),
    }
  );

documentsHttpClient.init({
  standardRequestStrategy: {
    getStandardRequest: () => {
      return {
        version: PORTAL_VERSION,
        brand: getAppBrand(),
      };
    },
  },
});

const documentsApiClient = new FleetRegistrationNoAuthService.ApiClient({
  httpClient: documentsHttpClient,
});

export default documentsApiClient;
